function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgObjectId(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "currentColor"
    },
    d: "M 10.027344 4.011719 L 4.011719 4.011719 C 2.90625 4.015625 2.015625 4.914062 2.015625 6.015625 L 2.003906 18.050781 C 2.007812 19.15625 2.90625 20.054688 4.011719 20.054688 L 20.054688 20.054688 C 21.164062 20.054688 22.058594 19.15625 22.0625 18.050781 L 22.0625 8.023438 C 22.058594 6.917969 21.164062 6.019531 20.054688 6.015625 L 12.035156 6.015625 Z M 10.027344 4.011719 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11.835938 13.195312 L 15.257812 13.195312 L 15.257812 9.773438 L 11.835938 9.773438 Z M 12.691406 10.628906 L 14.402344 10.628906 L 14.402344 12.339844 L 12.691406 12.339844 Z M 12.691406 10.628906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11.835938 17.472656 L 15.257812 17.472656 L 15.257812 14.050781 L 11.835938 14.050781 Z M 12.691406 14.90625 L 14.402344 14.90625 L 14.402344 16.617188 L 12.691406 16.617188 Z M 12.691406 14.90625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 16.113281 9.773438 L 16.113281 13.195312 L 19.535156 13.195312 L 19.535156 9.773438 Z M 18.679688 12.339844 L 16.96875 12.339844 L 16.96875 10.628906 L 18.679688 10.628906 Z M 18.679688 12.339844 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 18.796875 16.730469 L 19.664062 16.730469 L 19.664062 17.597656 L 18.796875 17.597656 Z M 18.796875 16.730469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 16.191406 14.128906 L 17.058594 14.128906 L 17.058594 14.996094 L 16.191406 14.996094 Z M 16.191406 14.128906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 17.058594 14.996094 L 17.929688 14.996094 L 17.929688 15.863281 L 17.058594 15.863281 Z M 17.058594 14.996094 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 16.191406 15.863281 L 17.058594 15.863281 L 17.058594 16.730469 L 16.191406 16.730469 Z M 16.191406 15.863281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 17.058594 16.730469 L 17.929688 16.730469 L 17.929688 17.597656 L 17.058594 17.597656 Z M 17.058594 16.730469 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 17.929688 15.863281 L 18.796875 15.863281 L 18.796875 16.730469 L 17.929688 16.730469 Z M 17.929688 15.863281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 17.929688 14.128906 L 18.796875 14.128906 L 18.796875 14.996094 L 17.929688 14.996094 Z M 17.929688 14.128906 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 18.796875 14.996094 L 19.664062 14.996094 L 19.664062 15.863281 L 18.796875 15.863281 Z M 18.796875 14.996094 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgObjectId);
export default __webpack_public_path__ + "static/media/object-id.bc45b2bcbd7e5564ca10fb0f3e6e7ddc.svg";
export { ForwardRef as ReactComponent };